export const TOGGLE_DEBUGGER = 'TOGGLE_DEBUGGER';
export const TOGGLE_CLOSEBUTTON = 'TOGGLE_CLOSEBUTTON';
export const TOGGLE_FONTSIZE = 'TOGGLE_FONTSIZE';

export const clickDebuggerButton = () => (dispatch, getState) => {
  const {chatRoot} = getState();

  chatRoot.debugFunc();

  return dispatch({
    type: TOGGLE_DEBUGGER
  });
};

export const clickCloseButton = () => (dispatch, getState) => {
  const {chatRoot} = getState();

  chatRoot.closeFunc();

  return dispatch({
    type: TOGGLE_CLOSEBUTTON
  });
};


export const toggleFontSize = (fontSize) => (dispatch) => {
  return dispatch({
    type: TOGGLE_FONTSIZE,
    fontSize
  });
};
